import { useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';

interface IInfoPageState {
    text?: string;
    title?: string;
}

function InfoPage() {
    const { text, title } = (useLocation().state || {}) as IInfoPageState;

    return (
        <div className="info-page h-100">
            <div className="d-flex flex-column align-items-center justify-content-center info-page-content">
                <a className="mb-5 login-app-logo" href="/">
                    <Logo />
                </a>
                <b>{title}</b>
                <p>{text}</p>
            </div>
        </div>
    );
}

export default InfoPage;
